import { EditOutlined } from "@ant-design/icons";
import { Col, Divider, Form, Input, Row, Typography } from "antd";
import { OTPProps } from "antd/es/input/OTP";
import { ConfirmLoginCodeProps } from "apps/Account/Modesl";
import { activateVerification } from "apps/Account/Services";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { handleSetUserInfoes } from "apps/CustomerPanel/Profile/ClientSideStates";
import { getUserInfoes } from "apps/CustomerPanel/Profile/Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import useMazakaForm from "hooks/useMazakaForm";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updatePhoneAfterVerify } from '../../../CustomerPanel/Profile/Services';
import { RootState } from "store/Reducers";
import { handleResetAllAdvertState } from "apps/CustomerPanel/Ad/ClientSideStates";


const ConfirmLoginCode: FC<ConfirmLoginCodeProps> = (props) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { adType } = useSelector((state: RootState) => state.ad);
  const getUserInformations = async () => {
    try {
      const response: any = await getUserInfoes();
      if (!props.isInstitutional && response?.data) {
        dispatch(handleSetUserInfoes({ data: response.data }));
      }
      else {

        mazakaForm.setSuccess(1000, () => "İşlem Başarılı");
        props.onFinish(response.data)
      }
    } catch (error: any) {
    } finally {
      // setIsLoading(false);
    }
  };

  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    const formValues = form.getFieldsValue();

    try {
      let response
      let response1
      if (Number(props.userType) === 3) {
        const data = {
          numberPrefix: props.numberPrefix,
          phoneNumber: props.numberBody,
          verificationCode: formValues.code,
          id: userInfoes.id
        };

        const data1 = {
          numberPrefix: props.numberPrefix,
          numberBody: props.numberBody,
          verificatedCode: formValues.code,
          email: props.email
        };

        response1 = await activateVerification(data1);
        localStorage.setItem("access_token", response1?.data || "");
        response = await updatePhoneAfterVerify(data)
      } else if (Number(props.userType) === 1) {

        const data = {
          numberPrefix: props.numberPrefix,
          phoneNumber: props.numberBody,
          verificationCode: formValues.code,
          id: userInfoes.id
        };
        const data1 = {
          numberPrefix: props.numberPrefix,
          numberBody: props.numberBody,
          verificatedCode: formValues.code,
          email: props.email
        };
        response1 = await activateVerification(data1);
        localStorage.setItem("access_token", response1?.data || "");
        response = await updatePhoneAfterVerify(data)
      }
      else {
        const data = {
          numberPrefix: props.numberPrefix,
          numberBody: props.numberBody,
          verificatedCode: formValues.code,
          email: props.email
        };
        response = await activateVerification(data);
        localStorage.setItem("access_token", response?.data || "");

      }
      getUserInformations();
    
      //getUserInformations();
      if (!props.isInstitutional) {
        mazakaForm.setSuccess(1000, () => "İşlem Başarılı");
        props.setIsShowConfirmCode(false);
        props.onFinish();
        if (props.pageType !== "advert"){
          navigate("/admin/panel");
          openNotificationWithIcon("default", response.message);
        }
          
        
      }
      form.resetFields();
      dispatch(handleResetAllAdvertState())
    } catch (error: any) {
      mazakaForm.setFailed(
        2000,
        error?.message || error?.Value?.Message || "Email ve ya şifre hatalı"
      );
      openNotificationWithIcon("default", error?.message);
      console.log("Somethings wrong during login to dashboard", error);
    }
  };

  const onChange = () => { };
  const sharedProps: OTPProps = {
    onChange,
  };

  return (
    <>
      <Col span={24} className="!mt-4">
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
        >
          <Row gutter={[10, 20]}>
            <Col xs={24}>
              <Row gutter={[0, 20]}>
                <Col xs={24} className="!flex justify-between">
                  <Text className="!text-black">
                    <span className="!font-bold">
                      {props.numberPrefix + props.numberBody}
                    </span>
                    'a Gönderilen Kodu Giriniz
                  </Text>
                  {
                    props.pageType !== "profile" &&
                    <>
                      <span
                        onClick={() => {
                          props.setIsShowConfirmCode(false);
                        }}
                        className="!ml-1 hover:cursor-pointer"
                      >
                        <EditOutlined className="!text-indigo-500 !text-xs" />
                        <Text className="!text-indigo-500 !text-xs">
                          Numarayı Değiştir
                        </Text>
                      </span>
                    </>
                  }
                </Col>
                <Col xs={24} className="!flex items-center" style={{ justifyContent: 'center !important' }}>
                  <Form.Item style={{ justifyContent: 'center !important', gap: '1px' }}
                    name="code"
                    rules={[
                      {
                        required: true,
                        message: "SMS ile gelen kodu giriniz!",
                      },
                      {
                        len: 6,
                        message: "Kod 6 karakter uzunluğunda olmalıdır!",
                      },
                    ]}
                    className="!w-full !justify-center"
                  >
                    <Input.OTP className="!justify-center"
                      length={6}
                      formatter={(str) => str.toUpperCase()}
                      {...sharedProps}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                block
                processType={formActions.submitProcessType}
              >
                Onayla
              </MazakaButton>
            </Col>

            <Col span={24}>
              <Divider className="!m-0" />
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default ConfirmLoginCode;
